import { z } from 'zod';

export const AssociatedBenefitFrequencySchema = z.enum(['ONCE', 'EACH_NIGHT']);
export type AssociatedBenefitFrequency = z.infer<
  typeof AssociatedBenefitFrequencySchema
>;
